var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSelectedWithGreyCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8056)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2009 33.3093L12.0117 23.1201L14.4295 20.7023L22.2009 28.3011L36.1895 14.3125L38.6072 16.7303L22.2009 33.3093Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSelectedWithGreyCircle);
export default __webpack_public_path__ + "static/media/not_selected_with_grey_circle.27c53784c9644b9d0133bb70426e5c8a.svg";
export { ForwardRef as ReactComponent };